import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    WorksheetSubmissionParams,
    failureWorksheetSubmission,
    successWorksheetSubmission,
} from "./worksheet_submission_slice";

// API call to submit worksheet for a scheduled class
const WorksheetSubmissionApi = (formData: FormData) => {
    return api.post('/api/schedule-class/create-edit-worksheet-submission', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Saga to handle worksheet submission
export function* WorksheetSubmissionCall(action: PayloadAction<WorksheetSubmissionParams>) {
    try {
        const response: AxiosResponse = yield call(WorksheetSubmissionApi, action.payload.formData);
        yield put(successWorksheetSubmission(response.data));
    } catch (error: any) {
        yield put(failureWorksheetSubmission(error.response?.data || error.message));
    }
}
